<template>
</template>

<script>
export default {
    data: function () {
        return {
            showWidget: true,
        }
    },
    props: [
    ],
    mounted() {
        this.checkScroll();
    },
    methods: {

        /**
         * Hide at bottom of page
         *
         * @return  {void}
         */
        checkScroll() {
            var self = this;
            window.onscroll = function() {
                if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 500) {
                    // you're at the bottom of the page
                    self.showWidget = false;
                } else {
                    self.showWidget = true;
                }
            };
        },
    },
}
</script>
